<template>
  <rpm-input
    type="checkbox"
    :label="!noLabel ? question.label:''"
    :required="!noLabel ? question.required:''"
    :optional="!noLabel ? !question.required:''"
    class="items-center"
  ></rpm-input>
</template>

<script>
export default {
  name: "CheckboxAnswer",
  props: {
    question: {
      type: Object,
      required: true
    },
    noLabel: {
      type: Boolean,
      default: false
    },
  },
};
</script>
